import React, { CSSProperties } from 'react';

import arrowRightBold from 'assets/icons/arrow-right-bold.svg';
import ChevronDown from 'assets/icons/chevron-down.svg';
import { ReactComponent as PinIcon } from 'assets/icons/pinn.svg';
import { ReactComponent as WhitePinIcon } from 'assets/icons/pinn-black.svg';
import { ReactComponent as MembersIcon } from 'assets/icons/members.svg';
import { ReactComponent as WhiteMembersIcon } from 'assets/icons/members-white.svg';
import { useAppSelector } from 'redux/hooks';
import { getCurrentScreenView } from 'redux/mobile_screen_flow/mobile_screen_flow.slice';

import './ChatCard.scoped.scss';

interface Props {
  style?: CSSProperties;
  children?: React.ReactNode;
  Header?: React.ReactNode;
}

interface Header {
  style?: CSSProperties;
  children?: React.ReactNode;
  title?: string;
  members?: number;
  arrow?: boolean;
  backButton?: boolean;
  pinButton?: boolean;
  membersButton?: boolean;
  goToScreen?: () => void;
  goToPinScreen?: () => void;
  goToMembersScreen?: () => void;
}
class Card extends React.Component<{ children?: React.ReactNode }> {
  static Header = (props: Header) => {
    const currentScreenView = useAppSelector(getCurrentScreenView);

    const renderPinIcon = () => {
      return currentScreenView !== 'pinned' ? (
        <div className="icon-wrapper active">
          <WhiteMembersIcon
            className="members-button active"
            onClick={() => props.goToMembersScreen()}
          />
        </div>
      ) : (
        <div className="icon-wrapper">
          <MembersIcon className={'members-button'} onClick={() => props.goToMembersScreen()} />
        </div>
      );
    };

    const isGroupChat = () => {
      if (props.members > 0) {
        return (
          <>
            <span className="chat-members">{props?.members}</span>
            {props.pinButton && renderPinIcon()}
          </>
        );
      }
      return null;
    };
    const renderMembersIcon = () => {
      return currentScreenView === 'pinned' ? (
        <div className="icon-wrapper active">
          <WhitePinIcon className="pin-button" onClick={() => props.goToPinScreen()} />
        </div>
      ) : (
        <div className="icon-wrapper">
          <PinIcon className="pin-button" onClick={() => props.goToPinScreen()} />
        </div>
      );
    };
    return (
      <div className={`chat-card-header ${currentScreenView}`} style={props.style}>
        {props.backButton && (
          <div className="flex">
            <img
              src={ChevronDown}
              alt="back button"
              className="back-button"
              onClick={() => props.goToScreen()}
            />
          </div>
        )}
        {props.arrow && <img src={arrowRightBold} alt="arrow right" />}
        <h2>
          <strong>{props.title}</strong>
        </h2>
        {props.children}
        <div className="flex align-center">
          {isGroupChat()}
          {props.membersButton && renderMembersIcon()}
        </div>
      </div>
    );
  };

  static Body = (props: Props) => (
    <div className="chat-card-body" style={props.style}>
      {props.children}
    </div>
  );

  render() {
    return <div className="chat-card-container">{this.props.children}</div>;
  }
}

export default Card;
